import { useMemo } from "react";

// Components
import { Box } from "@mui/material";
import {
  ErrorIcon,
  InfoIcon,
  SuccessIcon,
  WarningIcon,
} from "../../../assets/icons";

const Alert = ({ variant = "info", alertContent = "", ...props }) => {
  const variantColor = useMemo(() => {
    switch (variant) {
      case "error":
        return "#E10C0C";
      case "success":
        return "#22BE39";
      case "warning":
        return "#E7C43C";
      default:
        return "#48BECB";
    }
  }, [variant]);

  const variantIcon = useMemo(() => {
    switch (variant) {
      case "error":
        return <ErrorIcon color={variantColor} />;
      case "success":
        return <SuccessIcon color={variantColor} />;
      case "warning":
        return <WarningIcon color={variantColor} />;
      default:
        return <InfoIcon color={variantColor} />;
    }
  }, [variantColor, variant]);

  return (
    <Box
      display="flex"
      alignItems="center"
      gap="16px"
      p="16px"
      borderRadius="4px"
      backgroundColor={variantColor + "40"}
      fontSize="16px"
      {...props}
    >
      <Box display="flex" alignItems="center">
        {variantIcon}
      </Box>
      <Box display="flex" alignItems="center">
        {alertContent}
      </Box>
    </Box>
  );
};

export default Alert;
